import XLSXLink from './XLSXLink';

export default XLSXLink;
